import React, { useState } from 'react';
import { S } from '../../styles';
import { API, authHeaders } from '../../utils/helpers';

// Not a Settings group: a box inside Connections, in its own file because it
// keeps its own state (busy, error) and a group file must not
// (check-settings-groups.js). It never touches the settings object.
// The shop's own Spinboard subscription (18 Oct 2026). One button into Stripe's
// customer portal, already signed in as this shop: update the card, download
// invoices, cancel. The agreement promises cancelling "through Spinboard's
// billing portal or by email"; this is the portal. Owner only.
export default function SpinboardSubscription({ T }) {
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState('');
  const open = async () => {
    setBusy(true); setError('');
    try {
      const r = await fetch(`${API}/api/billing-portal`, { method:'POST', credentials:'include', headers: authHeaders() });
      const d = await r.json().catch(() => ({}));
      if (!r.ok || !d.url) throw new Error(d.error || 'Could not open the billing page.');
      window.location.href = d.url;
    } catch (e) {
      setError(e.message); setBusy(false);
    }
  };
  return (
    <div style={{ ...S.settingsCard, background:T.card, border:`1px solid ${T.cardBorder}` }}>
      <div style={{ ...S.settingsCardTitle, color:T.text }}>Spinboard Subscription</div>
      <div style={{ ...S.settingsCardDesc, color:T.textSub }}>
        Update the card Spinboard bills, download your invoices, or cancel. Opens Stripe's secure billing page, where Spinboard's billing is handled.
      </div>
      <div style={{ display:'flex', alignItems:'center', gap:12, flexWrap:'wrap' }}>
        <button onClick={open} disabled={busy}
          style={{ ...S.btn(false), color:T.text, borderColor:T.border, opacity: busy ? 0.6 : 1, cursor: busy ? 'default' : 'pointer' }}>
          {busy ? 'Opening…' : 'Manage billing'}
        </button>
        {error && <span style={{ fontSize:13, color:'#e74c3c' }}>{error}</span>}
      </div>
    </div>
  );
}
